import React, { useState } from "react";
import MapChart from "./MapChart";
import chevronIcon from "../../icons/chevron-right.svg";


const Localisation = ({ data }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const graphs = data?.graphs || [];
  const results = graphs[0]?.results || [];

  const handleRowClick = (row) => {
    setSelectedLocation(row);
  };

  return (
    <div className="grid grid-cols-12 gap-4">
      {/* Table Section */}
      <div className="col-span-5 ">
        <div className="space-y-4">
          {results.map((row, index) => (
            <div
              key={index}
              className="p-4 bg-white rounded-[12px] shadow-[0px_6px_26px_#626B7D12] flex justify-between items-center cursor-pointer"
              onClick={() => handleRowClick(row)}
            >
              <div>
                <p className="font-semibold text-[#38485C] text-[16px]">
                  {row.Commercial || ""}
                </p>
                <p className="font-semibold text-[#6B78F8] text-[12px]">
                  {row.Date || ""}
                </p>
              </div>
              <div>
              <img src={chevronIcon} alt="chevron" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Map Section */}
      <div className="col-span-7 bg-white p-[8px] rounded-[12px] shadow-md">
        <MapChart selectedLocation={selectedLocation} />
      </div>
    </div>

    
  );
};

export default Localisation;
